<template>
  <td>
    <div>
      <v-button
        @click="$modal.show(editAgencyNameModalName)"
        class="btn-primary"
      >
        Bearbeiten
      </v-button>
    </div>

    <modal
      :name="editAgencyNameModalName"
      :maxWidth="600"
      width="90%"
      height="auto"
      :adaptive="true"
      style="overflow: hidden"
    >
      <section class="p-3">
        <div class="form-group">
          <input type="text" class="form-control" v-model="name" />
        </div>
        <button @click="persist()" type="button" class="btn btn-primary">
          Speichern
        </button>
      </section>
    </modal>
  </td>
</template>

<script>
import { catchOutsideClicks } from "@/js/bodyClick.js";

export default {
  props: ["model", "tableId", "index"],
  data() {
    return {
      show: false,
      deleting: false,
      name: this.model.name
    };
  },
  mounted() {
    catchOutsideClicks(this.$refs.dropdown, () => {
      this.show = false;
    });
  },
  computed: {
    id() {
      return this.model.id;
    },
    editAgencyNameModalName() {
      return `agency-${this.id}-edit-modal`;
    }
  },
  methods: {
    persist() {
      this.disableModalActions = true;
      this.$http
        .patch("/api/v1/agency/" + this.id, {
          id: this.id,
          name: this.name
        })
        .then(() => {
          this.$modal.hide(this.editAgencyNameModalName);
          this.$notify({
            title: "Agentur erfolgreich bearbeitet",
            type: "success"
          });
          this.$emit("table-update", { count: true });
        })
        .finally(() => {
          this.disableModalActions = false;
        });
    }
  }
};
</script>
